"use client";

import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Search, Notifications } from "@mui/icons-material";
import Image from "next/image";
import { apiRemote, IUserParent } from "@/api";
import { useEffect, useState } from "react";
import { useDialog } from "@/hooks/use-dialog";
import ConfirmDialog, {
  ConfirmDialogButtonType,
} from "@/components/ConfirmDialog";
import { useAlert } from "@/contexts/AlertContext";
import { useUser } from "@/contexts/UserContext";
import { useNavigate } from "react-router";

interface ProfileParentProps {
  initialData?: IUserParent;
}

export default function Connected({ initialData }: ProfileParentProps) {
  const confirmDialog = useDialog();
  const navigate = useNavigate();
  var { user } = useUser();
  const alert = useAlert();
  const handleDisconnect = () => {
    // Handle disconnect logic
    confirmDialog.show({
      title: "Disconnect Parent",
      content: "Are you sure you want to disconnect from this account?",
      buttons: [
        {
          buttonType: ConfirmDialogButtonType.YES,
          onClick: () => {
            alert.showWait();
            // var userid = "166";
            apiRemote
              .connectParent({
                type: "disconnectparent",
                parent: initialData?.infoConnected.parent,
                child_id: user?.ID || '',
                // child_id: userid || "",
              })
              .then((res) => {
                if (res.code == 200) {
                  alert.success(res.message);

                  navigate(0);
                } else {
                  alert.error(res.message);
                }
              })
              .catch((err) => {
                alert.error(err.message);
                throw err;
              })
              .finally(() => {
                alert.hideWait();
              });
          },
        },
        {
          buttonType: ConfirmDialogButtonType.NO,
          onClick: () => {
            confirmDialog.hide();
          },
        },
      ],
    });
  };

  return (
    <Paper sx={{ p: 3 }}>
      <ConfirmDialog {...confirmDialog} />
      <Typography color="error" align="center" sx={{ mb: 3 }}>
        Your parent is already connected
      </Typography>

      <Box component="form" sx={{ mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Typography component="label" sx={{ mb: 1, display: "block" }}>
              First Name/Last name:
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  placeholder="First Name"
                  value={initialData?.infoConnected.firstname || ""}
                  disabled
                  size="small"
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      bgcolor: "#e9ecef",
                      WebkitTextFillColor: "#000000",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  placeholder="Last Name"
                  value={initialData?.infoConnected.lastname || ""}
                  disabled
                  size="small"
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      bgcolor: "#e9ecef",
                      WebkitTextFillColor: "#000000",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ mb: 2 }}>
            <Typography component="label" sx={{ mb: 1, display: "block" }}>
              Username:
            </Typography>
            <TextField
              fullWidth
              value={initialData?.infoConnected.username || ""}
              disabled
              size="small"
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  bgcolor: "#e9ecef",
                  WebkitTextFillColor: "#000000",
                },
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography component="label" sx={{ mb: 1, display: "block" }}>
              Email Address:
            </Typography>
            <TextField
              fullWidth
              value={initialData?.infoConnected.email || ""}
              disabled
              size="small"
              sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                  bgcolor: "#e9ecef",
                  WebkitTextFillColor: "#000000",
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          onClick={handleDisconnect}
          sx={{
            bgcolor: "#ff4d00",
            "&:hover": {
              bgcolor: "#cc3d00",
            },
          }}
        >
          Disconnect
        </Button>
      </Box>
    </Paper>
  );
}
